module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec04_4032e5e98d2b029b7cc8efbed08b0506.jpg";